// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"HomeMainSec_Wrapper__3_yOe","LineWrapper":"HomeMainSec_LineWrapper__2hKzW","Line":"HomeMainSec_Line__dWWDo"};